import { render, staticRenderFns } from "./SwapIn.vue?vue&type=template&id=2cf837ba&"
import script from "./SwapIn.vue?vue&type=script&lang=ts&"
export * from "./SwapIn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports